import React from 'react';
import Dialog from 'material-ui/Dialog';
import Paper from 'material-ui/Paper';
import { Menu, MenuItem } from 'material-ui';
import './style.scss';

function TagsModal({ open, setOpen, allTags, pushToTagsSearch }) {
    const addTagToSearch = (tag) => {
        pushToTagsSearch({ ...tag, name: tag.value });
        setOpen(false);
    };

    return (
        <Dialog 
            open={open}
            onRequestClose={() => setOpen(false)}
            autoScrollBodyContent
        >
            {
                allTags.map((tag, index) => {
                    return (
                        <div
                            key={`${tag.value}_${index}`}
                            style={{ marginBottom: '10px' }}
                        >
                            <Paper 
                                zDepth={1} 
                                className='paper_tag'
                            >
                                <Menu
                                    listStyle={{ paddingTop: 0, paddingBottom: 0 }}
                                >
                                    <MenuItem 
                                        primaryText={tag.value}
                                        onClick={() => addTagToSearch(tag)}
                                        style={{
                                            backgroundColor: 'none',
                                            fontSize: '13px',
                                            wordBreak: 'break-word',
                                            whiteSpace: 'unset',
                                        }}
                                    />
                                </Menu>
                            </Paper>
                        </div>
                    );
                })
            }
        </Dialog>
    );
}

export default TagsModal;



// WEBPACK FOOTER //
// ./app/components/Analytics/TagsModal.jsx